import { createSlice } from '@reduxjs/toolkit';
import { ListFilterModel } from '../../models/listFilter.model';

const initialState: ListFilterModel = {
	roles: '',
	stages: [],
	all_external_managers: [],
	recruiting_managers: [],
	all_companies: [],
	states: [],
	isFilterRequired: false,
	isRecruitingManagersRequired: false,
};

const listFilterReducerSlice = createSlice({
	name: 'listFilterReducer',
	initialState,
	reducers: {
		setListQueryFilters(state: ListFilterModel, action) {
			return { ...state, ...action.payload };
		},
		resetListQueryFilters(state: ListFilterModel, action) {
			return initialState;
		},
	},
});

export const { setListQueryFilters, resetListQueryFilters } =
	listFilterReducerSlice.actions;
export default listFilterReducerSlice.reducer;
